import React, { useMemo }  from "react";
import { connect  } from "react-redux";
import { useParams,useLocation } from 'react-router-dom';
import EmployeeTab from "./components/EmployeeTab";
import EmployeeProfile from "./components/EmployeeProfile";


const ViewEmployee = () => { 
	const { employeeId } = useParams();
	const location = useLocation();

	const startTab = useMemo(() => {
		if (location.pathname.includes("/salary")) return "salary";
		if (location.pathname.includes("/schedule")) return "schedule";
		if (location.pathname.includes("/settings")) return "settings";
		return "details"; 
	}, [location.pathname]);
    
	return (
	    <div className="grid h-full grid-cols-1 gap-6">
			<EmployeeProfile withDesignation={true} recordId={employeeId} />
			<EmployeeTab recordId={employeeId} startTab={startTab} />
		</div>
    );
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmployee);